import React, { ChangeEvent } from 'react';
import Icon from './Icon';
import { twMerge } from 'tailwind-merge';

interface CheckboxProps {
    disabled?: boolean;
    onChange: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
    checked: boolean;
    label?: React.ReactNode;
    className?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({
    disabled,
    onChange,
    checked,
    label,
    className,
}) => {
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        onChange(event, event.target.checked);
    };

    return (
        <label className={twMerge('flex items-center gap-x-1', className)}>
            <div className="relative">
                <input
                    type="checkbox"
                    checked={checked}
                    disabled={disabled}
                    onChange={handleChange}
                    className="peer sr-only absolute"
                />
                <div className="hidden peer-checked:block">
                    <Icon iconKey="checkboxChecked" />
                </div>
                <div className="block peer-checked:hidden">
                    <Icon iconKey="checkboxUnChecked" />
                </div>
            </div>
            {label ? (
                <span className="text-sm text-gray-700">{label}</span>
            ) : null}
        </label>
    );
};

export default Checkbox;
